// LanguageSelector.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Select, MenuItem, FormControl } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {/* Ícono de traducción a la izquierda */}
      <TranslateIcon sx={{ mr: 1 }} />

      {/* Select sin línea inferior ni bordes, usando variant="standard" y disableUnderline */}
      <FormControl variant="standard" sx={{ color: '#fff' }}>
        <Select
          value={i18n.language}
          onChange={handleChange}
          disableUnderline
          sx={{
            color: '#fff',      // Texto del select en blanco
            fontSize: '0.9rem',
            '.MuiSvgIcon-root': {
              color: '#fff',    // Flecha del desplegable en blanco
            },
          }}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="es">Español</MenuItem>          
          <MenuItem value="cr">Kreyòl</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;

